import React from "react"
import NavbarCartItem from "../NavbarCartItem/NavbarCartItem"

import style from "./BottomCartItem.module"
import throttle from "lodash/throttle";

const SM = 992

export default class BottomCartItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }

    this.ref = React.createRef()
  }

  componentDidMount() {
    document.addEventListener("scroll", this.onScroll)

    if (window.innerWidth < SM) {
      this.setState({ visible: true })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.onScroll)
  }

  onScroll = throttle(() => {
    if (!this.ref) {
      return
    }

    if (window.pageYOffset > 180) {
      this.setState({ visible: true })
    } else {
      this.setState({ visible: false })
    }
  }, 300)

  render() {
    const { storeUrl, isStorePage } = this.props
    const { visible } = this.state

    return (
      <div
        ref={this.ref}
        className={`${style.container} ${
          visible ? style.visible : style.hidden
        }`}
      >
        <NavbarCartItem storeUrl={storeUrl} isStorePage={true} />
      </div>
    )
  }
}
